import React from 'react';
import logo from './logo.svg';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import './App.css';
import LoginPage from './screens/loginScreen/login';
import OTPVerifyLogin from './screens/loginScreen/otpVerifyLogin';
import Home from './screens/Home';
import CurrentAffairs from './screens/CurrentAffairs/CurrentAffairsModal';
import MyTests from './screens/TestSeries/testSeriesList';
import TestSeriesTestList from './screens/TestSeries/testSeriesTestList';
import FullScreenWebView from './screens/fullScreenWebView';
import TestDetails from './screens/TestSeries/testDetails';
import ShowResultsScreen from './screens/showResultsScreen';
import QuizScreen from './screens/quizScreen';
import TestTermsAndConditions from './screens/quizScreen/testTermsAndConditions';
import SelectedAnswersScreen from './screens/quizScreen/selectedAnswerScreen';
import RegisterPage from './screens/loginScreen/newRegister';
import RegisterVerifyOtp from './screens/loginScreen/registrationVerifyOtp';
import CourseExamScreen from './screens/courseScreen/index';
import Courses from './screens/courseScreen/courses';
import LessonPlanner from './screens/courseScreen/lessonPlanner';
import LessonContent from './screens/courseScreen/lessonContent';
import LibraryExamScreen from './screens/libraryScreen/index';
import LibrarySubjectsScreen from './screens/libraryScreen/subjectsLibrary';
import TopicsLibraryBooks from './screens/libraryScreen/topicsLibrary'
import ContentLibraryScreen from './screens/libraryScreen/libraryContent';
import AboutScreen from './screens/AboutScreen/index';
import AppTermsAndConditionsScreen from './screens/appTermsAndCondtionsScreen/TermsAndConditions';
import DisclaimerScreen from './screens/disclaimerScreen/';
import PrivacyAndPolicyScreen from './screens/privacyPolicyScreen/';
import ChangePhoneNumberScreen from './screens/changePhoneNumberScreen'; 
import VerifyChangeNumber from './screens/changePhoneNumberScreen/verifyChangeNumberScreen';
import EditProfileScreen from './screens/editProfileScreen';
import PaymentScreen from './screens/paymentScreen';
import ListOfCurrentAffairsScreen from  './screens/CurrentAffairs';

function App() {
  return(
    <Router>
      <Switch>
          <Route exact path='/' component={LoginPage} />
          <Route exact path='/OtpScreen/:mobile' component={OTPVerifyLogin} />
          <Route exact path='/Home' component={Home} />
          <Route exact path='/CurrentAffairs/:titleId' component={CurrentAffairs} />
          <Route exact path='/MyTests' component={MyTests} />
          <Route exact path='/TestSeriesTestList' component={TestSeriesTestList} />
          <Route exact path='/FullScreenWebView' component={FullScreenWebView} />
          <Route exact path='/TestDetails' component={TestDetails} />
          <Route exact path='/ShowResults' component={ShowResultsScreen} />
          <Route exact path='/TestAttempt' component={QuizScreen} />
          <Route exact path='/TestTerms' component={TestTermsAndConditions} />
          <Route exact path='/Selected' component={SelectedAnswersScreen} />
          <Route exact path='/register' component={RegisterPage} />
          <Route exact path='/registrationVerifyOtpScreen' component={RegisterVerifyOtp} />
          <Route exact path='/courseExam' component={CourseExamScreen} />
          <Route exact path='/courses/:examId' component={Courses} />
          <Route exact path='/lessonPlanner' component={LessonPlanner} />
          <Route exact path='/courseMaterial' component={LessonContent} />
          <Route exact path='/libraryExam' component={LibraryExamScreen} />
          <Route exact path='/librarySubject/:examId' component={LibrarySubjectsScreen} />
          <Route exact path='/topicLibraryBooks' component={TopicsLibraryBooks} />
          <Route exact path='/contentLibraryScreen' component={ContentLibraryScreen} />
          <Route exact path='/aboutUs' component={AboutScreen} />
          <Route exact path='/termsAndCondition' component={AppTermsAndConditionsScreen} />
          <Route exact path='/disclaimer' component={DisclaimerScreen} />
          <Route exact path='/privacyAndPolicy' component={PrivacyAndPolicyScreen} />
          <Route exact path='/changePhoneNumber' component={ChangePhoneNumberScreen} />
          <Route exact path='/verifyChangeNumber' component={VerifyChangeNumber} />
          <Route exact path='/editProfile' component={EditProfileScreen} />
          <Route exact path='/Payment' component={PaymentScreen} />
          <Route exact path='/ListOfCurrentAffairs' component={ListOfCurrentAffairsScreen} />
      </Switch>
    </Router>
  );
}

export default App;
